import styled from '@emotion/styled'

export const S = {
  SwitchFiltersWrapper: styled.section`
    display: flex;
    align-items: center;
    justify-content: space-between;
  `,
}
